export const CANDIDATE_RECRUITMENT_STATUSES = {
	NEW: 'new',
	ACCEPTED: 'accepted',
	HIRED: 'hired',
	REJECTED: 'rejected',
};

export const STATUSES_LABELS = [
	{
		weight: 0,
		label: 'New',
		value: CANDIDATE_RECRUITMENT_STATUSES.NEW,
	},
	{
		weight: 1,
		label: 'Accepted',
		value: CANDIDATE_RECRUITMENT_STATUSES.ACCEPTED,
	},
	{
		weight: 2,
		label: 'Hired',
		value: CANDIDATE_RECRUITMENT_STATUSES.HIRED,
	},
	{
		weight: 3,
		label: 'Rejected',
		value: CANDIDATE_RECRUITMENT_STATUSES.REJECTED,
	},
];
